import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from './ui/button';
import { Alert } from './ui/alert';
import { LinkIcon } from '@heroicons/react/24/outline';

const AddCompetitorFormNew = ({ addCompetitorLink }) => {
  const [competitorLink, setCompetitorLink] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!competitorLink.includes('basalam.com')) {
      toast.error('لطفاً فقط لینک محصولات باسلام را وارد کنید');
      return;
    }

    try {
      setIsSubmitting(true);
      await addCompetitorLink(competitorLink);
      setCompetitorLink('');
      toast.success('رقیب با موفقیت اضافه شد');
    } catch (error) {
      console.error('Error in AddCompetitorForm:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-4">
      <Alert className="border-blue-200 bg-blue-50">
        <LinkIcon className="h-4 w-4 text-blue-600" />
        <div className="mr-3">
          <p className="text-sm text-blue-800">
            <strong>نکته:</strong> لینک محصول رقیب را از باسلام کپی کرده و اینجا وارد کنید
          </p>
          <p className="text-xs text-blue-600 mt-1">
            مثال: https://basalam.com/p/123456
          </p>
        </div>
      </Alert>

      <form onSubmit={handleSubmit} className="flex flex-col md:flex-row gap-3">
        <div className="flex-1">
          <input
            type="url"
            value={competitorLink}
            onChange={(e) => setCompetitorLink(e.target.value)}
            placeholder="https://basalam.com/p/..."
            className="w-full h-10 px-3 py-2 text-sm rounded-md border border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            required
          />
        </div>
        <Button
          type="submit"
          disabled={isSubmitting}
          className="w-full md:w-auto bg-blue-600 hover:bg-blue-700"
        >
          {isSubmitting ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white ml-2"></div>
              در حال افزودن...
            </>
          ) : (
            <>
              <LinkIcon className="h-4 w-4 ml-2" />
              افزودن رقیب
            </>
          )}
        </Button>
      </form>
    </div>
  );
};

export default AddCompetitorFormNew;
